export function isValidHexColor(color: string): boolean {
  const colorHexValidatorRegExp = /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/;
  return !!color && color.length === 7 && colorHexValidatorRegExp.test(color);
}

// normalize hex colors to #RRGGBB uppercase, return undefined for invalid
export function normalizeHex(input: string | null | undefined): string | undefined {
  if (!input) {
    return undefined;
  }

  let s = String(input).trim();
  if (!s.startsWith("#")) {
    s = `#${s}`;
  }

  if (/^#[0-9a-fA-F]{3}$/.test(s)) {
    return (
      "#" +
      s
        .substring(1)
        .split("")
        .map(c => c + c)
        .join("")
        .toUpperCase()
    );
  }

  if (/^#[0-9a-fA-F]{6}$/.test(s)) {
    return s.toUpperCase();
  }

  return undefined;
}

export function normalizeHexOrLinearGradient(input: string | null | undefined): string | undefined {
  if (!input) {
    return undefined;
  }

  const raw = String(input).trim();
  if (!raw) {
    return undefined;
  }

  // accept linear-gradient(...) (keep as-is; gradients can contain rgba(), var(), etc.)
  if (/^linear-gradient\(\s*.+\s*\)$/i.test(raw)) {
    return raw;
  }

  // otherwise parse as hex
  return normalizeHex(input);
}
